/**
 * Calls a function if it is defined
 *
 * @param {Function} fn - Function to be called
 * @param  {...any} args
 */
export function callFunctionIfDefined(fn, ...args) {
  fn && fn(...args)
}
